require('slick-carousel');

let slides = $('.featured-slide .slick');

export default {
  fire() {
    slides.slick({
      arrows: true,
      mobileFirst: true,
      adaptiveHeight: true,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/components/featured-slider.js